export default __webpack_public_path__ + "static/media/pd9.e2402b8f.jpg";